// extracted by mini-css-extract-plugin
export default {"navigationMenu":"ClickOutsideCloseContent__navigationMenu","customMenu":"ClickOutsideCloseContent__customMenu"};